var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#ECEEF2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 25,
    height: 16,
    rx: 2,
    fill: "#7C55EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3719 16.5V23.5H12.5119V21.1H13.8719C15.5319 21.1 16.8619 20.58 16.8619 18.8C16.8619 17.02 15.5319 16.5 13.8719 16.5H11.3719ZM15.7019 18.8C15.7019 19.82 14.8919 20.06 13.9319 20.06H12.5119V17.54H13.9319C14.9019 17.54 15.7019 17.78 15.7019 18.8ZM18.2027 16.5V23.5H20.6527C23.1327 23.5 24.3327 22.03 24.3327 20C24.3327 17.97 23.1327 16.5 20.6527 16.5H18.2027ZM23.1727 20C23.1727 21.57 22.3027 22.46 20.6427 22.46H19.3427V17.54H20.6427C22.3027 17.54 23.1727 18.43 23.1727 20ZM25.8148 16.5V23.5H26.9548V20.66H30.3548V19.6H26.9548V17.55H30.6448V16.5H25.8148Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.e6677dea1af75f31baf18c0f4ae0e142.svg";
export { ForwardRef as ReactComponent };